import { SchemeEditorDefaultMessage } from '@modules/planning/children/scheme-editor/types/components';

export const SCHEME_EDITOR_DEFAULT_MESSAGE: SchemeEditorDefaultMessage = {
  UPLOAD_SCHEME: { loading: 'Загрузка обновления схемы...', success: 'Новая схема применена' },
  CUR_SCHEME: { loading: 'Загрузка текущей схемы...', success: 'Схема загружена' },
  MAX_SCHEME: { loading: 'Подготовка шаблонов...', success: 'Шаблоны подготовлены' }
};

export const SCHEME_EDITOR_KEY_PREFIX = 'SCHEME_EDITOR';
